module.exports = __webpack_public_path__ + "img/nz.9e4572e7.svg";